/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../../../core/has.js";
import { isNone as e } from "../../../../../core/maybe.js";
import { getGraphicEffectiveElevationMode as r, hasGraphicFeatureExpressionInfo as o } from "../../../../../support/elevationInfoUtils.js";

function t(t) {
  var n;
  if ("graphics" !== (null == (n = t.layer) ? void 0 : n.type)) return 1;
  if (e(t.geometry)) return 2;

  switch (t.geometry.type) {
    case "polygon":
    case "point":
    case "polyline":
    case "mesh":
      break;

    default:
      return 3;
  }

  return "on-the-ground" !== r(t) && o(t) ? 4 : 0;
}

export { t as isSupportedGraphic };